<template>
    <div class="h-100">
      <div v-for="r in remate" class="card card-triangle rounded-0 border-0 shadow w-100 h-100 bg-darkPrimary px-0 pt-0 pb-2">
        <div class="card-header bg-transparent rounded-0 border-0 p-0 pb-0">
        <span class="bg-white d-flex justify-content-center align-items-center px-3 pt-4">
          <img v-bind:src="'/storage/' + r.imagen" :alt="r.nombre"
               class="img-fluid consignatario">
        </span>
        </div>
        <div class="card-body d-flex justify-content-center align-items-center px-3 py-2">
          <div class="text-white text-center">
            <p class="p-sm font-AR text-nowrap mb-1">Mirá todos los remates de</p>
            <h4 class="font-ARB mb-0">{{ r.titulo }}</h4>
          </div>
        </div>
        <div class="card-footer ver-detalle-card bg-transparent border-0 d-flex justify-content-center p-0">
          <div class="btn btn-applePrimary btn-sm font-ARB text-darkPrimary mt-2 mb-2" @click="submit">Ver remates</div>
        </div>
      </div>

    </div>
</template>

<script>
export default {
  mounted() {
  },
  props: ['remates', 'remate'],
  methods: {
    submit: function () {
      let url = '/remates?';

      for (let param in this.form.consignatario) {
        if (this.form.consignatario[param] != null) {
          url += `consignatario[]=${this.form.consignatario[param]}&`;
        }
      }

      console.log(url);
      window.open(url, '_blank')
    },
  },
  data() {
    return {
      submitted: false,
      form: {
        consignatario: this.remate.map( c => {
          return c.id
        })
      }
    }
  }
};
</script>
<style lang="scss"></style>
